export class FilterModel {
    public filterKey: string;
    public pageNumber: number;
    public perPage: number;
}



// WEBPACK FOOTER //
// ./src/models/filter.model.ts